import { Box, Tabs } from "@mui/material";
import { styled } from "@mui/material/styles";
import { FontSize600, FontSize700, SpaceXs, FontLineHeightSm, FontWeightBold, ColorGray500, SizeBorderWidthThin, SpaceXxs, SpaceMd, ColorCostcoBlue } from "@nxt-costco-com/forge-design-tokens";
import { Text } from "../../DataDisplay/Text/index.js";
const SectionHeadingText = styled(Text)(({ theme }) => ({
  flex: "1 0 0",
  fontSize: "2.625rem",
  //42px
  fontWeight: FontWeightBold,
  lineHeight: FontLineHeightSm,
  marginBottom: SpaceXs,
  textAlign: "left",
  [theme.breakpoints.down("lg")]: {
    fontSize: FontSize700,
    //28px
    lineHeight: 1.14
  },
  [theme.breakpoints.down("md")]: {
    fontSize: FontSize600,
    //24px
    lineHeight: 1.16
    //28px
  }
}));
const TabAreaContainer = styled(Box)(() => ({
  minWidth: "100%",
  maxWidth: "100%"
}));
const TabPanelContainer = styled(Box)(() => ({
  paddingTop: SpaceXs,
  width: "100%"
}));
const TabsContainer = styled(Box)(() => ({
  width: "100%",
  display: "flex",
  alignItems: "flex-start",
  alignContent: "flex-start",
  gap: SpaceMd,
  alignSelf: "stretch",
  flexWrap: "wrap",
  paddingTop: SpaceXxs,
  borderBottomStyle: "solid",
  borderBottomWidth: SizeBorderWidthThin,
  borderBottomColor: ColorGray500
}));
const StyledTabs = styled(Tabs)(() => ({
  minHeight: "33px",
  "& .MuiTabs-indicator": {
    height: "3px",
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent"
  },
  "& .MuiTabs-indicatorSpan": {
    width: "100%",
    backgroundColor: ColorCostcoBlue
  },
  "& .MuiTabs-flexContainer": {
    gap: SpaceMd
  }
}));
export {
  SectionHeadingText,
  StyledTabs,
  TabAreaContainer,
  TabPanelContainer,
  TabsContainer
};
